import React from "react";
import { RedirectType } from "@admin/domain/notifications/models/NotificationModel";
import RedirectTypeRadioButton from "@admin/pages/NotificationEditor/RedirectTypeRadioButton";
import ProductCategoriesSearch from "@admin/components/ProductCategoriesSearch";
import { searchNews } from "@admin/domain/news/api";
import SearchInput from "@admin/components/SearchInput";
import { searchProducts } from "@admin/domain/products/api";
import { searchLiveBroadcasts } from "@admin/domain/uniquePages/api";
import Input from "@admin/components/Input";

type Props = {
    redirectType: RedirectType | null;
    redirectEntityValue: number | string | null;
    redirectEntityTitle: string | null;
};

export default function PushRedirectSettings({
    redirectType: initRedirectType,
    redirectEntityValue,
    redirectEntityTitle,
}: Props) {
    const [redirectType, setRedirectType] = React.useState<RedirectType | null>(initRedirectType || null);

    const currentEntityValue = initRedirectType === redirectType ? redirectEntityValue : null;

    const currentEntityTitle = initRedirectType === redirectType ? redirectEntityTitle : null;

    return (
        <div className="rounded border p-6 mb-5">
            <h3>Настройки редиректа</h3>
            <RedirectTypeRadioButton
                redirectType={RedirectType.ProductCategory}
                redirectTypeState={redirectType}
                onChange={setRedirectType}
            />

            {redirectType === RedirectType.ProductCategory && (
                <ProductCategoriesSearch
                    inputName="parameters[redirect_entity_value]"
                    categoryIds={currentEntityValue ? +currentEntityValue : null}
                    isMulti={false}
                />
            )}

            <RedirectTypeRadioButton
                redirectType={RedirectType.Product}
                redirectTypeState={redirectType}
                onChange={setRedirectType}
            />

            {redirectType === RedirectType.Product && (
                <SearchInput
                    inputName="parameters[redirect_entity_value]"
                    searchRequest={searchProducts}
                    selectedEntityId={currentEntityValue || null}
                    selectedEntityTitle={currentEntityTitle || null}
                    placeholder="Поиск по названию продукта / артикулу"
                />
            )}

            <RedirectTypeRadioButton
                redirectType={RedirectType.NewsArticle}
                redirectTypeState={redirectType}
                onChange={setRedirectType}
            />

            {redirectType === RedirectType.NewsArticle && (
                <SearchInput
                    inputName="parameters[redirect_entity_value]"
                    searchRequest={searchNews}
                    selectedEntityId={currentEntityValue || null}
                    selectedEntityTitle={currentEntityTitle || null}
                    placeholder="Поиск по названию новости"
                />
            )}

            <RedirectTypeRadioButton
                redirectType={RedirectType.LiveBroadcast}
                redirectTypeState={redirectType}
                onChange={setRedirectType}
            />

            {redirectType === RedirectType.LiveBroadcast && (
                <SearchInput
                    inputName="parameters[redirect_entity_value]"
                    searchRequest={searchLiveBroadcasts}
                    selectedEntityId={currentEntityValue || null}
                    selectedEntityTitle={currentEntityTitle || null}
                    placeholder="Поиск по названию живого эфира"
                    isSearchable={false}
                />
            )}

            <RedirectTypeRadioButton
                redirectType={RedirectType.Url}
                redirectTypeState={redirectType}
                onChange={setRedirectType}
            />

            {redirectType === RedirectType.Url && (
                <Input
                    name="parameters[redirect_entity_value]"
                    placeholder="Введите ссылку на страницу"
                    defaultValue={currentEntityValue || ``}
                />
            )}
        </div>
    );
}
